import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { TransportManagementFiltersFacade } from './transport-management-filters.facade';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class TransportManagementFiltersGuard {
  constructor(private transportManagementFiltersFacade: TransportManagementFiltersFacade) {}
  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.transportManagementFiltersFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.transportManagementFiltersFacade);
  }
}
